export const normalizeTypeId = (value) => {
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const normalizeItemId = (value) => normalizeTypeId(value);

export const isActive = (value) => Number(value) === 1;

export const normalizeSelectedItems = (selectedItems) => {
  if (Array.isArray(selectedItems)) {
    return selectedItems.reduce((map, itemId) => {
      const normalizedId = normalizeItemId(itemId);
      if (normalizedId) map[normalizedId] = true;
      return map;
    }, {});
  }

  if (selectedItems && typeof selectedItems === "object") {
    return Object.keys(selectedItems).reduce((map, itemId) => {
      if (selectedItems[itemId]) {
        const normalizedId = normalizeItemId(itemId);
        if (normalizedId) map[normalizedId] = true;
      }
      return map;
    }, {});
  }

  return {};
};

export const normalizeSelectedMethodItems = (methodItems) => {
  if (!Array.isArray(methodItems)) return {};

  return methodItems.reduce((map, item) => {
    const id = normalizeItemId(item && (item.method_item_id !== undefined ? item.method_item_id : item.id));
    if (id) map[id] = true;
    return map;
  }, {});
};

export const countSelectedItems = (selectedItems) => Object.keys(normalizeSelectedItems(selectedItems)).length;

export const getPartTypeId = (partData) => {
  if (!partData || typeof partData !== "object") return null;

  const objectValue = partData.method_item_type && partData.method_item_type.value
    ? normalizeTypeId(partData.method_item_type.value)
    : null;

  return objectValue || normalizeTypeId(partData.method_item_type_id);
};
